import "./article_themepage.css";

export const themePage = (obj) => {
	const padding =
		obj.bodyTextJustify === "start"
			? " pl-md-0"
			: obj.bodyTextJustify === "end"
				? " pr-md-0"
				: "";
	const themeColor = obj.temaFarge ? obj.temaFarge : "#FFFFFF";

	let bgColorStyle = `background-color: ${themeColor}`;
	if (window.serverdata.configMeta.aim.style.view?.theme__header_bg_fade) {
		bgColorStyle = `background-image: linear-gradient(${themeColor}, #ffffff)`;
	}
	const bgColor = standardizeColor(themeColor);
	const bgColorRGB = hexToRgb(bgColor);
	const threshold = 0.5;

	const r = bgColorRGB.r * 0.2126;
	const g = bgColorRGB.g * 0.7152;
	const b = bgColorRGB.b * 0.0722;
	const sum = r + g + b;
	const perceivedLightness = sum / 255;
	const alpha = perceivedLightness - threshold < 0 ? "100%" : "0%";

	let txtColor = "#000000";
	if (!themeColor.indexOf("linear-gradient") >= 0) {
		// shows either white or black color depending on perceived darkness
		txtColor = `hsl(0deg, 100%, ${alpha})`;
		// hsl(0, 0%, calc((var(--perceived-lightness) - var(--threshold)) * -10000000%));
	}

	return `
    <div class="theme theme__main ${obj.pageTypeId}">
      <div class="row m-0" style="${bgColorStyle};">
        <div class="container p-md-0 theme__header__container">
            <div class="theme__header">
                <h1 class="article__header" style='color: ${txtColor};'>${
									obj.title
								}</h1>
                ${
									obj.intro.length > 2
										? `<div class="article__intro" style='color: ${txtColor};'>${obj.intro}</div>`
										: ""
								}
            </div>
            ${obj.hasImage ? `${obj.mainImage}` : ""}
        </div>
      </div>
      <div class="row m-0 theme__content__text">
          <div class="container justify-content-${obj.bodyTextJustify + padding} d-flex theme__content">
              <div class="col-md-12 px-0${padding}">
                  ${obj.content}
              </div>
          </div>
      </div>    
    </div>`;
};
export const themePageImage = (obj) => {
	return `
        <div class="article__introimage__container p-0 col-md-6">
            <img src="" alt="" class="article__introimage" id="${obj.id}" >
        </div>
    `;
};

function hexToRgb(hex) {
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	return result
		? {
				r: Number.parseInt(result[1], 16),
				g: Number.parseInt(result[2], 16),
				b: Number.parseInt(result[3], 16),
			}
		: null;
}

function standardizeColor(str) {
	const ctx = document.createElement("canvas").getContext("2d");
	ctx.fillStyle = str;
	return ctx.fillStyle;
}
